import { Table, Typography } from 'antd';
import { useMemo } from 'react';
import { learningSpaceRequirementsMarked } from '../Block61';
import { supportiveToolsMarked } from '../Block62';
import { FormBlock6DataTypes } from './DocumentPreviewSubjectData';
import { PreviewNestedData } from './PreviewNestedData';

type DocumentPreviewBock6Props = {
  data: FormBlock6DataTypes;
};

export const DocumentPreviewBlock6 = ({ data }: DocumentPreviewBock6Props) => {
  const tableData = useMemo(() => {
    const changedTableData = {
      space: {
        key: 'space',
        space: {},
      },
      tools: {
        key: 'tools',
        tools: {},
      },
    };
    if (data.space) {
      changedTableData.space.space = (
        <PreviewNestedData
          fieldsData={{ ...data.space }}
          fieldsConfig={{
            ...learningSpaceRequirementsMarked,
          }}
        />
      );
    }
    if (data.tools) {
      changedTableData.tools.tools = (
        <PreviewNestedData
          fieldsData={{ ...data.tools }}
          fieldsConfig={{
            ...supportiveToolsMarked,
          }}
        />
      );
    }
    return changedTableData;
  }, [data]);

  return (
    <div>
      <Typography.Title level={5}>
        Programos įgyvendinimo sąlygos
      </Typography.Title>
      <Table
        pagination={false}
        columns={[
          {
            key: 'space',
            title: 'Ugdymosi vietos ir (ar) aplinkos pritaikymas',
            dataIndex: 'space',
          },
        ]}
        dataSource={[tableData.space || {}]}
        size="small"
      />
      <Table
        pagination={false}
        columns={[
          {
            key: 'tools',
            title: 'Specialiosios mokymo priemonės',
            dataIndex: 'tools',
          },
        ]}
        dataSource={[tableData.tools || {}]}
        size="small"
      />
    </div>
  );
};
